<template>
  <span
    @click="handleClick"
    v-if="isReactionsVisible"
    v-tooltip="{
      content: iconTooltipContent,
      offset: 0,
    }"
    class="flex items-center"
  >
    <img
      v-for="(reaction, index) in reactions"
      :key="reaction.iconName"
      :src="reaction.icon"
      :alt="reaction.iconName"
      width="16"
      height="16"
      class="inline-block"
      :class="{ '-mr-0.5 relative': index === 0 }"
    >
    <span
      class="ml-1 text-xs text-base-80"
      :class="{ 'text-reaction-report': isReport}"
    >
      <AhaFormatter
        :value="numberOfReactions"
        :locale="presentation.language"
        type="KMB"
      />
    </span>
  </span>
</template>

<script>
// icons
import like from '@/assets/images/reactions/like.svg'
import heart from '@/assets/images/reactions/heart.svg'
import laugh from '@/assets/images/reactions/laugh.svg'
import sad from '@/assets/images/reactions/sad.svg'
import wow from '@/assets/images/reactions/wow.svg'

/**
 * @deprecated Use ReactionsV2 instead
 */
export default {
  props: {
    presentation: {
      type: Object,
      required: true,
    },
    isReport: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      like,
      heart,
      laugh,
      wow,
      sad,
    }
  },
  computed: {
    isReactionsVisible() {
      return this.numberOfReactions !== 0 &&
            this.presentation.reactions &&
            Object.values(this.presentation.reactions).some((reaction) => reaction === true)
    },
    isReactionLikeVisible() {
      return this.presentation.numberOfLikes &&
        this.presentation.reactions && this.presentation.reactions.like
    },
    isReactionHeartVisible() {
      return this.presentation.numberOfHearts &&
        this.presentation.reactions && this.presentation.reactions.heart
    },
    isReactionLaughVisible() {
      return this.presentation.numberOfLaughs &&
        this.presentation.reactions && this.presentation.reactions.laugh
    },
    isReactionWowVisible() {
      return this.presentation.numberOfWows &&
        this.presentation.reactions && this.presentation.reactions.wow
    },
    isReactionSadVisible() {
      return this.presentation.numberOfSads &&
        this.presentation.reactions && this.presentation.reactions.sad
    },
    iconTooltipContent() {
      let text = ''

      if (this.isReactionLikeVisible) {
        text += `
          <img class='inline-block mr-1' src='${like}' width='16' height='16' />
          <span class='number-of-reactions'>${this.$func.formatter(this.presentation.numberOfLikes, 'KMB', this.presentation.language)}</span>
        `
      }

      if (this.isReactionHeartVisible) {
        text += `
          <img class='inline-block mr-1' src='${heart}' width='16' height='16' />
          <span class='number-of-reactions'>${this.$func.formatter(this.presentation.numberOfHearts, 'KMB', this.presentation.language)}</span>
        `
      }

      if (this.isReactionLaughVisible) {
        text += `
          <img class='inline-block mr-1' src='${laugh}' width='16' height='16' />
          <span class='number-of-reactions'>${this.$func.formatter(this.presentation.numberOfLaughs, 'KMB', this.presentation.language)}</span>
        `
      }

      if (this.isReactionWowVisible) {
        text += `
          <img class='inline-block mr-1' src='${wow}' width='16' height='16' />
          <span class='number-of-reactions'>${this.$func.formatter(this.presentation.numberOfWows, 'KMB', this.presentation.language)}</span>
        `
      }

      if (this.isReactionSadVisible) {
        text += `
          <img class='inline-block mr-1' src='${sad}' width='16' height='16' />
          <span class='number-of-reactions'>${this.$func.formatter(this.presentation.numberOfSads, 'KMB', this.presentation.language)}</span>
        `
      }

      return `<div class='flex items-center'>${text}</div>`
    },
    reactions() {
      const reactions = [
        {
          icon: like,
          iconName: 'like',
          numberOfReactions: this.presentation.numberOfLikes,
        },
        {
          icon: heart,
          iconName: 'heart',
          numberOfReactions: this.presentation.numberOfHearts,
        },
        {
          icon: laugh,
          iconName: 'laugh',
          numberOfReactions: this.presentation.numberOfLaughs,
        },
        {
          icon: wow,
          iconName: 'wow',
          numberOfReactions: this.presentation.numberOfWows,
        },
        {
          icon: sad,
          iconName: 'sad',
          numberOfReactions: this.presentation.numberOfSads,
        },
      ]

      return reactions
        .filter((reaction) => reaction.numberOfReactions &&
                              this.presentation.reactions &&
                              this.presentation.reactions[reaction.iconName])
        .sort((a, b) => b.numberOfReactions - a.numberOfReactions)
        .slice(0, 2)
    },
    numberOfReactions() {
      const {
        numberOfLikes,
        numberOfHearts,
        numberOfLaughs,
        numberOfWows,
        numberOfSads,
      } = this.presentation

      return numberOfLikes + numberOfHearts + numberOfLaughs + numberOfWows + numberOfSads
    },
  },
  methods: {
    handleClick(e) {
      this.$emit('click', e)
    },
  },
}
</script>

<style lang="scss">
.number-of-reactions {
  @apply mr-3;

  &:last-child {
    @apply mr-0;
  }
}
.text-reaction-report{
  font-size: 16px;
}
</style>
